import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'semantic-ui-react'

class InputField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false
    };

    this.focus = this.focus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  focus() {
    this.setState({ active: !this.state.active })
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.props.validateWithEnter();
    } else {
      return
    }
  }

  render() {

    return (
      <Form.TextArea
        ref={(ref) => this.textarea = ref}
        {...this.props.input}
        onFocus={this.focus}
        onBlur={this.focus}
        onKeyDown={this.handleKeyDown}
        placeholder={this.state.active ? '' : this.props.label}
        rows={1}
        error={this.props.meta.touched && this.props.meta.error ? true : null}
      />
    )
  }
}

InputField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
}

export default InputField



// WEBPACK FOOTER //
// ./src/views/components/InputField.js